import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import HeaderPanel from './../../HeaderPanel';
import FooterPanel from './../../FooterPanel';
import AboutHeroPanel from "./AboutHeroPanel";
import AboutPanel from "./AboutPanel";
import EventPanel from "./../../EventPanel";

const useStyles = theme => ({
    branding: {
        display: 'flex',
        flexWrap: 'wrap',
    },
});

class AboutPage extends React.Component {
  myRef = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {
    let self = this;
  }

  componentWillUnmount() {
  }

  render() {
    const { classes } = this.props;

    let self = this;

      return (
          <div className={classes.branding}>
              <HeaderPanel showLogo={true} ref={this.myRef} page={'about'} />
              <AboutHeroPanel />
              <AboutPanel />
              <EventPanel />
              <FooterPanel />
          </div>
      );
  }
}

export default withStyles(useStyles)(AboutPage)
